import { render, staticRenderFns } from "./BannerMediaCreateAndUpdateFormItems.vue?vue&type=template&id=ab319944&"
import script from "./BannerMediaCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./BannerMediaCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports